module.exports = __webpack_public_path__ + "img/signature-brun.9b8a3c92.png";